/**
 * TODO
 * Use the browser event system to broadcast a message to reload the auth state
 * Have listeners triggered by the message to reload the auth state
 * Support registering / unregistering listeners
 * Run as a singleton
 */

import { apiClientHooks } from "../bootstrapping/InitApiClient"
import { queryClient } from "../bootstrapping/InitReactQuery"
import { BackoffSafeguard } from "./backoffSafeguard"

const backoffSafeguard = new BackoffSafeguard(10, 60_0000) // Allow up to 10 reloads within 10 minutes

type ReloadAuthAction = (() => Promise<void>) | undefined
export const reloadAuthActions: Record<'auth0Jwt' | 'idTokenClaims' | 'profileJWT', ReloadAuthAction> = {
  // Reload the Auth0 Access and ID tokens
  auth0Jwt: undefined, // This is set in InitAuth0RequiringLogin.tsx, as it's used within React
  idTokenClaims: undefined, // This is set in useIdTokenClaims.tsx, as it's used within React
  // Once we have an updated Access Token, we can refetch the Profile JWT
  profileJWT: async () => {
    console.info('Reloading the Profile JWT...')
    await queryClient.refetchQueries({ queryKey: apiClientHooks.getKeyByAlias('getMyProfile') })
    // At this point:
    // - The Auth0 Access Token is refreshed (used for getMyProfile)
    // - The Auth0 ID Token is refreshed (used for getMyInvites)
    // - The Profile JWT is refreshed (used for everything else, but we don't need to manually refresh these, they will update as they go stale)
  },
}

export const doReloadAuth = async () => {
  if (process.env.NODE_ENV === 'development') {
    console.log('[useReloadAuth] Reloading auth state, if allowed...')
  }

  await backoffSafeguard.callIfAllowed(async () => {
    if (process.env.NODE_ENV === 'development') {
      console.log('[useReloadAuth] Doing the reloading of auth state...')
    }
    reloadAuthActions.auth0Jwt && await reloadAuthActions.auth0Jwt()
    reloadAuthActions.idTokenClaims && await reloadAuthActions.idTokenClaims()
    reloadAuthActions.profileJWT && await reloadAuthActions.profileJWT()
  })
}
